/**
 * CardHeader Component
 *
 * Header sub-component for compound Card API
 * Provides flexible container with layout variants for icons, titles, badges, and actions
 * Enhanced with space-between, alignment options, and custom CSS override support
 */

import React from 'react';
import { css, cx } from '@/styled-system/css';
import { cardHeaderVariants } from './card.styles';
import type { CardHeaderProps } from './types';

export const CardHeader = React.forwardRef<HTMLElement, CardHeaderProps>(
  ({ children, className, layout = 'default', align = 'center', css: customCss, ...restProps }, ref) => {
    // Generate header styles with layout variants
    const headerStyles = cardHeaderVariants({ layout, align });

    // Apply custom CSS override if provided
    const customStyles = customCss ? css(customCss) : '';

    return (
      <header ref={ref} className={cx(headerStyles, customStyles, className)} {...restProps}>
        {children}
      </header>
    );
  },
);

CardHeader.displayName = 'CardHeader';

export type { CardHeaderProps };
